import React, { useState, useEffect } from 'react';
import { Card, Typography, Spin, message, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface DocumentDetailProps {
  documentId: string;
  documentTitle: string;
  documentContent: string;
  onBack: () => void;
}

const DocumentDetail: React.FC<DocumentDetailProps> = ({
  documentId,
  documentTitle,
  documentContent,
  onBack
}): JSX.Element => {
  return (
    <div style={{ padding: '24px' }}>
      <Button 
        icon={<ArrowLeftOutlined />} 
        onClick={onBack}
        style={{ marginBottom: '16px' }}
      >
        返回搜索結果
      </Button>
      
      <Card>
        <Title level={2}>{documentTitle}</Title>
        <Paragraph>
          <Text strong>文檔ID: </Text>
          <Text code>{documentId}</Text>
        </Paragraph>
        
        <Title level={4}>文檔內容</Title>
        <Paragraph style={{ whiteSpace: 'pre-wrap', lineHeight: '1.8' }}>
          {documentContent}
        </Paragraph>
      </Card>
    </div>
  );
};

export default DocumentDetail;